<div class="flex flex-col">
  <div class="p-4 space-x-3 bg-project-600 rounded-t-md text-project-2400">
    <h3 class="flex items-center text-sm text-inherit">Chapters</h3>
  </div>
</div>
<div class="w-full p-4 bg-white">
  <div *ngIf="!isDisabled">
    <mat-checkbox class="text-xs" [formControl]="onlySelectedEditionsControl" data-testId="onlySelectedEditions">
      Only selected editions
    </mat-checkbox>
    <mat-form-field appearance="outline" class="flex flex-col flex-1 w-full">
      <input
        matInput
        [formControl]="searchBarControl"
        [name]="'search'"
        [placeholder]="'Search for content'"
      />
      <button
        *ngIf="searchBarControl.value"
        mat-icon-button
        matSuffix
        (click)="clearSearch()"
        data-testid="clearSearch"
      >
        <mat-icon matSuffix>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div
    *ngIf="
      chapterDisplayList && chapterDisplayList.length && !isSearchingChapter;
      else noData
    "
    class="mb-2 space-y-1 overflow-y-auto divide-y bg-project-2500 h-80 divide-project-600"
  >
    <div
      *ngFor="let chapter of chapterDisplayList"
      class="p-1 cursor-pointer"
      (click)="handleArticleSelected(chapter)"
      data-testid="chapterSearchResult"
    >
      <p class="text-xxs text-project-2400" data-testid="chapterPublishedDate">
        {{ chapter.publishedDate | formatDateOnlyPipe }}
      </p>
      <p [value]="chapter" class="text-xs break-normal" data-testid="chapterTitle">
        {{ chapter.title }}
      </p>
    </div>
    <button
      *ngIf="!isLoadingMore && hasMoreResults"
      mat-raised-button
      class="w-full h-8 my-1 text-xs font-semibold bg-project-200 text-project-500"
      (click)="loadMore(); $event.stopPropagation()" data-testid="loadMoreResults"
    >
      Load More<i class="mx-2 icon icon-repeat"></i>
    </button>
    <div
      *ngIf="isLoadingMore"
      class="flex items-center justify-center w-full pb-4 text-xs gap-x-2 text-project-2100"
    >
      <span>Loading more</span>
      <mat-spinner [diameter]="12"></mat-spinner>
    </div>
  </div>
  <ng-template #noData>
    <mat-option
      *ngIf="!!searchBarControl.value && !isSearchingChapter"
      disabled
    >
      No results
    </mat-option>
  </ng-template>
  <div
    cdkDropList
    class="space-y-2"
    [cdkDropListDisabled]="isDisabled"
    (cdkDropListDropped)="drop($event.previousIndex, $event.currentIndex)"
  >
    <div
      class="flex justify-between bg-project-2200 text-project-2400"
      *ngFor="let chapter of chapterControl.value; let index = index"
      cdkDrag data-testid="chapterDragItem"
    >
      <div class="flex p-5 text-xs">
        ORDER <span class="px-1 mx-2 bg-white h-min">{{ index + 1 }}</span>
        <a
          [href]="goToContent(chapter)"
          target="_blank"
          class="underline text-project-500"
          data-testid="chapterLink"
          >{{ chapter.linkTitle }}</a
        >
      </div>
      <button
        *ngIf="!isDisabled"
        class="p-3 text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
        data-testid="removeBtn"
        title="Remove"
        (click)="onRemove(chapter)"
      >
        <i class="icon icon-remove"></i>
      </button>
    </div>
    <div *ngIf="isDisabled && !chapterControl?.value?.length" class="text-xs">
      No chapters added
    </div>
  </div>
</div>
